module.exports = __webpack_public_path__ + "static/Boiler_form_RU-6eb2ac4548f41e75e4aa47b0f2912bbf.pdf";